export default "__VITE_ASSET__BGdrJbqd__"